
export default {
  name: 'PopupAttachmentButton',
}
